import NotionLogo from '../icons/NotionLogo';
import { Diamond } from '../Ornaments/Diamond';
import { LighterCircle } from '../Ornaments/LighterCirlce';
import { PinkPolygon } from '../Ornaments/PinkPolygon';
import { Star } from '../Ornaments/Star';
import { Testimonial } from './Testimonial';

export const Notion = () => {
  return (
    <Testimonial
      company={<NotionLogo className="w-[60px] h-[60px]" />}
      quote="Transcend has helped us uplevel our compliance. We came to them with a legacy compliance system that was quite broken and over the last 6 months or so, it’s only been good news from our internal teams! Excited to keep this partnership going!"
      author={
        <>
          <span className="font-medium">Jalal Iftikhar</span>, Head of Business
          Technology
        </>
      }
    >
      <LighterCircle className="absolute ml:top-[calc(50%-400px)] top-100 ml:-right-450 -right-100 ml:w-800 w-200 origin-center -rotate-90 blur-sm " />
      <PinkPolygon className="absolute top-40 right-[20vw] ml:w-220 w-100 blur-sm" />
      <Diamond className="absolute bottom-100 ml:right-350 right-50 blur-sm ml:blur-none ml:w-100 w-50" />
      <Star className="absolute ml:bottom-180 ml:-left-100 -left-50 ml:w-270 w-135 top-90 ml:top-auto" />
    </Testimonial>
  );
};
